import React from "react";
import { Typography } from "@mui/material";
import { getEventStatusText, getEventTypeFromEventObject } from "../../../../../helpers/common";
import { DEFAULT_DATE_FORMAT, fDate } from "../../../../../utils/formatTime";
import IsMobile from "../../../../../hooks/isMobile";
import { iEventType } from "../../../../../types/eventTypes";
import { ICorporateEvent, ICorporateEventMessage } from "../../../../../interfaces/corporateEvent";
import { IEventDetailMessages } from "../../../../../types/eventTypes";
import { EventTypeFilterEnum } from "../../../../../constants/enums";
import { getFullName } from "../../../../../utils/commonUtils";
import "./ChatHeaderMetadata.scss";

interface ChatHeaderMetadataProps {
	eventDetail: iEventType | ICorporateEvent;
	chatMessage: IEventDetailMessages | ICorporateEventMessage;
}

const ChatHeaderMetadata: React.FC<ChatHeaderMetadataProps> = ({ eventDetail, chatMessage }) => {
	const isMobile = IsMobile();
	const eventType = getEventTypeFromEventObject(eventDetail);
	const b2cEvent = eventType !== EventTypeFilterEnum.B2B ? (eventDetail as iEventType) : undefined;
	const b2bEvent = eventType === EventTypeFilterEnum.B2B ? (eventDetail as ICorporateEvent) : undefined;

	const statusText = getEventStatusText(eventDetail.status, eventType, true).text;
	const formattedDate =
		eventType !== EventTypeFilterEnum.B2B
			? fDate(b2cEvent?.eventDate || "", DEFAULT_DATE_FORMAT)
			: fDate(b2bEvent?.startDate || "", DEFAULT_DATE_FORMAT);

	const getCustomerName = () => {
		if (eventType !== EventTypeFilterEnum.B2B) {
			return getFullName(b2cEvent?.customer?.firstName || "", b2cEvent?.customer?.lastName || "");
		}
		return b2bEvent?.corporateClient?.brandName || b2bEvent?.corporateClient?.legalName || "";
	};

	const metadataParts = [statusText, getCustomerName(), formattedDate].filter(Boolean);

	return (
		<Typography className="chatHeaderMetadata">
			{isMobile ? getCustomerName() : metadataParts.join(" • ")}
		</Typography>
	);
};

export default ChatHeaderMetadata;
